import type { TFunction } from "@/hooks/useTranslation"

export const getScanTypeOptions = (t: TFunction) =>
  [
    { label: t("options.prScan"), value: "PR" },
    { label: t("options.ciScan"), value: "CI" }
  ] as const

export const getShowOptions = (t: TFunction) =>
  [
    { label: t("options.all"), value: "" },
    { label: t("options.passed"), value: "passed" },
    {
      label: t("options.warn_and_pass"),
      value: "warn_and_pass"
    },
    { label: t("options.failed"), value: "failed" }
  ] as const

export const findOptionsLabel = (
  options:
    ReturnType<typeof getScanTypeOptions> | ReturnType<typeof getShowOptions>,
  value: string
) => options.find((option) => option.value === value)?.label || ""

export const getStatusTranslationKey = (status: string) => {
  if (status === "passed") return "status.passed_scanned"

  return `status.${status}`
}
